import TweenMax from 'gsap/umd/TweenMax';

// TODO: if more 12 months
// TODO: update (change timestamp)
// TODO: don't stop after tab blur (check blur and restart after focus back)

class Countdown {
  constructor(timestamp, { onUpdate, onComplete }) {
    this.running = false;
    this.tween = null;
    this.timestamp = timestamp;
    this.offset = {
      seconds: 0,
      minutes: 0,
      hours: 0,
      days: 0,
      months: 0,
    };

    if (onUpdate && typeof onUpdate === 'function') {
      this.onUpdate = onUpdate;
    }

    if (onComplete && typeof onComplete === 'function') {
      this.onComplete = onComplete;
    }
  }

  start() {
    if (this.running) return;
    this.running = true;

    if (!this.timestamp) return;

    const now = Date.now();

    if (this.timestamp <= now) {
      if (this.onComplete) {
        this.onComplete();
      }
      return;
    }

    const ms = this.timestamp - now;
    const left = { ms };

    let lastSeconds;

    this.tween = TweenMax.to(left, ms / 1000, {
      ms: 0,
      ease: 'Linear.easeNone',
      useFrames: false,
      onUpdate: () => {
        const seconds = Math.floor(left.ms / 1000);

        if (lastSeconds === seconds) return;
        lastSeconds = seconds;

        this.offset.seconds = seconds % 60;
        this.offset.minutes = Math.floor(seconds / 60) % 60;
        this.offset.hours = Math.floor((seconds / 60 / 60) % 24);
        this.offset.days = Math.floor((seconds / 60 / 60 / 24) % 30.4368);
        this.offset.months = Math.floor(seconds / 60 / 60 / 24 / 30.4368);

        if (this.onUpdate) {
          this.onUpdate(this.offset);
        }
      },
      onComplete: () => {
        this.running = false;

        if (this.onComplete) {
          this.onComplete();
        }
      },
    });
  }

  destroy() {
    this.running = false;
    this.tween.kill();
    this.tween = null;
  }
}

export default Countdown;
